<template>
    <div class="wizard-forms wizard-forms__confirmation">
        <div id="toggle" class="row">
            <br />
            <div class="col-md-10 col-md-offset-1 dynamic-landing--disabled">
                <div class="vrm-info-box--flex">
                    <span
                        v-html="
                            $t(`dynamicess.toggle`, {
                                i18nFallback: `Toggle Dynamic ESS controls for this installation. By turning this on, you will be able to toggle the Dynamic ESS mode (On/Off) from the Controls menu on your installation's dashboard.`,
                            })
                        "
                    ></span>
                    <vrm-controlled-toggle disabled :value="false" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10 col-md-offset-1">
                <div
                    class="dynamic-ess-config-btn sg-btn__container sg-btn__container--align-right"
                >
                    <button
                        class="sg-btn sg-blue pull-right"
                        :disabled="!userCanEdit"
                        @click.prevent="$emit('config')"
                    >
                        <span v-if="isConfigurationEmpty">
                            {{
                                $t('dynamicess.landing.config', {
                                    i18nFallback: 'Start configuration',
                                })
                            }}
                        </span>
                        <span v-else>
                            {{
                                $t('dynamicess.landing.configContinue', {
                                    i18nFallback: 'Continue configuration',
                                })
                            }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row dynamic-landing--item">
            <div class="col-md-10 col-md-offset-1">
                <div class="dynamic-landing--title">
                    {{ $t('dynamicess.landing.title', { i18nFallback: `What do you need?` }) }}
                </div>
                <div
                    class="dynamic-landing-description"
                    v-html="$t('dynamicess.landing.description', { i18nFallback: essDescription })"
                ></div>
            </div>
        </div>
        <div class="row dynamic-landing--item">
            <div class="col-md-10 col-md-offset-1">
                <div class="dynamic-landing--title">
                    {{
                        $t('dynamicess.landing.configuring', {
                            i18nFallback: 'Configuring Dynamic ESS',
                        })
                    }}
                </div>
                <div class="dynamic-landing-description">
                    {{
                        $t('dynamicess.landing.configuringDescription', {
                            i18nFallback:
                                'After completing setting up Dynamic ESS for the first time you can always change the configuration on this screen.',
                        })
                    }}
                </div>
            </div>
        </div>
        <div class="row dynamic-landing--item">
            <div class="col-md-10 col-md-offset-1">
                <div class="dynamic-landing--title">
                    {{ $t('dynamicess.landing.faq', { i18nFallback: 'FAQ and troubleshooting' }) }}
                </div>
                <div class="dynamic-landing-description">
                    {{
                        $t('dynamicess.landing.faqDescription', {
                            i18nFallback:
                                'If you feel stuck at any point of the configuration please visit our community FAQ thread. If your question is not listed, feel free to post your difficulty under the same thread.',
                        })
                    }}
                </div>
            </div>
        </div>
        <div class="row dynamic-ess-btn">
            <div class="col-md-10 col-md-offset-1">
                <div class="sg-btn__container dynamic-ess-community-btn">
                    <a
                        href="https://community.victronenergy.com/t/about-the-dess-category/1589"
                        target="__blank"
                        class="sg-btn sg-site dynamic-ess-community-link"
                    >
                        {{
                            $t('dynamicess.landing.visit', { i18nFallback: 'Visit our community' })
                        }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmControlledToggle from '@/vue/components/shared/toggles/VrmControlledToggle';

@Component({
    components: {
        VrmControlledToggle,
    },
    data: {},
})
export default class Landing extends Vue {
    @Prop()
    userCanEdit;
    @Prop()
    isConfigurationEmpty;

    essDescription =
        "Completing this configuration takes about 15 minutes. You will need information about: </br></br> <ul> <li> your grid connection specifications </li> <li> your battery system specifications  </li> <li> your energy contract. </li> </ul> </br> </br> For sites that include solar, setting your location improves the forecasts Dynamic ESS uses. </br> </br> For Dynamic ESS to work, your installation should have <a href='https://www.victronenergy.com/live/vrm_portal:dashboard#real_time_data' target='_blank'> 'two-way communication' <a/> enabled.";
}
</script>
